import React from "react";
import {
  Clock,
  AlertTriangle,
  TrendingUp,
  MapPin,
  Calendar,
  Timer,
  X,
  Download,
  CheckCircle,
  PauseCircle,
} from "lucide-react";

const AnalisisDemorasModal = ({ tramo, onClose }) => {
  if (!tramo) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [paradas, setParadas] = React.useState([]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [loadingParadas, setLoadingParadas] = React.useState(true);

  // Cargar análisis de paradas al abrir el modal
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(() => {
    const cargarAnalisisParadas = async () => {
      try {
        const API_BASE_URL =
          process.env.REACT_APP_VILOX_FLOTA_API || "http://localhost:8080";
        const response = await fetch(
          `${API_BASE_URL}/api/analisis-paradas/tramo/${tramo.id}`,
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setParadas(data);
          console.log("✅ Paradas detectadas:", data.length);
        }
      } catch (error) {
        console.error("❌ Error cargando paradas:", error);
      } finally {
        setLoadingParadas(false);
      }
    };

    cargarAnalisisParadas();
  }, [tramo.id]);

  const formatearMinutos = (minutos) => {
    if (!minutos || minutos === 0) return "0 min";
    const horas = Math.floor(Math.abs(minutos) / 60);
    const mins = Math.abs(minutos) % 60;
    return horas > 0 ? `${horas}h ${mins}min` : `${mins}min`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "--:--";
    const date = new Date(dateString);
    return date.toLocaleString("es-PE", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return "--:--";
    const date = new Date(dateString);
    return date.toLocaleTimeString("es-PE", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const getSemaforoColor = (semaforo) => {
    switch (semaforo) {
      case "VERDE":
        return "bg-green-500";
      case "AMARILLO":
        return "bg-yellow-500";
      case "ROJO":
        return "bg-red-500";
      default:
        return "bg-gray-400";
    }
  };

  const calcularDuracionTransito = () => {
    if (!tramo.horaSalidaReal || !tramo.horaLlegadaRealDestino) return null;
    const inicio = new Date(tramo.horaSalidaReal);
    const fin = new Date(tramo.horaLlegadaRealDestino);
    return Math.round((fin - inicio) / (1000 * 60)); // minutos
  };

  const duracionTransito = calcularDuracionTransito();

  // GENERADOR DE REPORTE

  const generarReporte = () => {
    const reporte = `
╔════════════════════════════════════════════════════════════════╗
║         ANÁLISIS DETALLADO DE DEMORAS - TRAMO ${tramo.orden}              ║
╚════════════════════════════════════════════════════════════════╝

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📍 ESTABLECIMIENTO ORIGEN: ${tramo.establecimientoOrigen?.nombre || "N/A"}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🕐 Llegada Programada:  ${formatDateTime(tramo.horaLlegadaProgramada)}
🕐 Llegada Real:         ${formatDateTime(tramo.horaLlegadaReal)}
⏱️  Tardanza:            ${tramo.tardanzaCita1 || 0} minutos

📍 Entrada Zona Interna: ${formatDateTime(
      tramo.horaEntradaGeocercaInternaOrigen
    )}
📍 Salida Zona Interna:  ${formatDateTime(tramo.horaSalidaReal)}
⏱️  Tiempo Permanencia:  ${tramo.tiempoPermanenciaCita1 || 0} min
⏱️  Tiempo Atención:     ${tramo.tiempoAtencionCita1 || 0} min

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🚚 TRÁNSITO (Origen → Destino)
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🕐 Inicio:               ${formatDateTime(tramo.horaSalidaReal)}
🕐 Fin:                  ${formatDateTime(tramo.horaLlegadaRealDestino)}
⏱️  Duración:            ${duracionTransito || "N/A"} minutos

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🎯 ESTABLECIMIENTO DESTINO: ${tramo.establecimientoDestino?.nombre || "N/A"}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

🕐 Llegada Programada:  ${formatDateTime(tramo.horaSalidaProgramada)}
🕐 Llegada Real:         ${formatDateTime(tramo.horaLlegadaRealDestino)}
⏱️  Tardanza:            ${tramo.tardanzaCita2 || 0} minutos

📍 Entrada Zona Interna: ${formatDateTime(
      tramo.horaEntradaGeocercaInternaDestino
    )}
📍 Salida Zona Interna:  ${formatDateTime(tramo.horaSalidaRealDestino)}
⏱️  Tiempo Permanencia:  ${tramo.tiempoPermanenciaCita2 || 0} min
⏱️  Tiempo Atención:     ${tramo.tiempoAtencionCita2 || 0} min
⏱️  SLA Establecido:     ${tramo.slaMinutos || "N/A"} minutos

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📊 ANÁLISIS DE DEMORAS (ETA)
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

${tramo.etaProgramado ? `⏰ ETA Programado:       ${tramo.etaProgramado}` : ""}
${tramo.eta ? `⏰ ETA Actual:           ${tramo.eta}` : ""}
${
  tramo.minutosRetraso
    ? `⚠️  Demora Acumulada:    +${formatearMinutos(tramo.minutosRetraso)}`
    : ""
}
${
  tramo.demoraSalida
    ? `⚠️  Demora en Salida:    +${formatearMinutos(tramo.demoraSalida)}`
    : ""
}
🚦 Semáforo:             ${tramo.semaforo || "N/A"}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📈 RESUMEN EJECUTIVO
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

✓ Tardanza Total:        ${
      (tramo.tardanzaCita1 || 0) + (tramo.tardanzaCita2 || 0)
    } minutos
✓ Tiempo en Origen:      ${tramo.tiempoPermanenciaCita1 || 0} minutos
✓ Tiempo en Destino:     ${tramo.tiempoPermanenciaCita2 || 0} minutos
✓ Tiempo en Tránsito:    ${duracionTransito || "N/A"} minutos
✓ Estado General:        ${tramo.estado.toUpperCase()}
✓ Avance GPS:            ${tramo.avance || 0}%

${tramo.observaciones ? `\n📋 Observaciones: ${tramo.observaciones}` : ""}

════════════════════════════════════════════════════════════════
Generado: ${new Date().toLocaleString("es-PE")}
════════════════════════════════════════════════════════════════
    `;

    const blob = new Blob([reporte], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Analisis_Tramo_${tramo.orden}_${new Date()
      .toISOString()
      .slice(0, 10)}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-hidden">
        {/* HEADER */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="bg-white text-indigo-600 rounded-full w-10 h-10 flex items-center justify-center font-bold text-lg">
              {tramo.orden}
            </div>
            <div>
              <h2 className="text-xl font-bold text-white">
                Análisis Detallado de Demoras y Tiempos
              </h2>
              <p className="text-indigo-100 text-sm">
                {tramo.establecimientoOrigen?.nombre || "Origen"} →{" "}
                {tramo.establecimientoDestino?.nombre || "Destino"}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="h-5 w-5 text-white" />
          </button>
        </div>

        {/* CONTENIDO */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
          {/* COLUMNA 1: ETA Y DEMORAS */}
          <div className="mb-6">
            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-lg p-6 border-2 border-indigo-200">
              <h3 className="text-lg font-bold text-indigo-900 mb-4 flex items-center">
                <Clock className="h-5 w-5 mr-2" />
                📊 Estado Actual del Tramo
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* ETA Actual */}
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-600">
                      ETA Actual
                    </span>
                    <div
                      className={`w-3 h-3 rounded-full ${getSemaforoColor(
                        tramo.semaforo
                      )} animate-pulse`}
                    ></div>
                  </div>

                  <div
                    className={`font-bold text-gray-900 ${
                      tramo.eta?.length > 8 ? "text-2xl" : "text-3xl"
                    }`}
                  >
                    {/* Quitamos el .split(" ")[0] para que no corte el texto */}
                    {tramo.eta || "--:--"}
                  </div>

                  {tramo.minutosRetraso > 0 && (
                    <div className="mt-2 text-sm text-red-600 font-semibold">
                      +{formatearMinutos(tramo.minutosRetraso)}
                    </div>
                  )}
                </div>

                {/* ETA Programado */}
                {tramo.etaProgramado && (
                  <div className="bg-white rounded-lg p-4 shadow-sm">
                    <div className="flex items-center mb-2">
                      <Calendar className="h-4 w-4 text-gray-500 mr-2" />
                      <span className="text-sm font-medium text-gray-600">
                        ETA Programado
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-gray-700">
                      {tramo.etaProgramado}
                    </div>
                  </div>
                )}

                {/* Avance */}
                <div className="bg-white rounded-lg p-4 shadow-sm">
                  <div className="flex items-center mb-2">
                    <TrendingUp className="h-4 w-4 text-gray-500 mr-2" />
                    <span className="text-sm font-medium text-gray-600">
                      Avance GPS
                    </span>
                  </div>
                  <div className="text-3xl font-bold text-indigo-600">
                    {tramo.avance || 0}%
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                    <div
                      className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full transition-all"
                      style={{ width: `${tramo.avance || 0}%` }}
                    ></div>
                  </div>
                </div>
              </div>

              {/* Demora en Salida */}
              {tramo.demoraSalida > 0 && (
                <div className="mt-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <Timer className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                    <div className="flex-1">
                      <div className="text-sm font-bold text-yellow-900 mb-2">
                        ⚠️ Demora en Salida del Origen
                      </div>
                      <div className="grid grid-cols-2 gap-3 text-sm">
                        <div>
                          <span className="text-gray-600">Programado:</span>
                          <div className="font-semibold text-gray-900">
                            {formatTime(tramo.horaSalidaProgramada)}
                          </div>
                        </div>
                        <div>
                          <span className="text-gray-600">Real:</span>
                          <div className="font-semibold text-gray-900">
                            {formatTime(tramo.horaSalidaReal)}
                          </div>
                        </div>
                      </div>
                      <div className="mt-2 text-xl font-bold text-yellow-700">
                        Demora: +{formatearMinutos(tramo.demoraSalida)}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Demora Acumulada */}
              {tramo.minutosRetraso > 0 && (
                <div className="mt-4 bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <AlertTriangle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
                    <div className="flex-1">
                      <div className="text-sm font-bold text-red-900 mb-1">
                        🚨 Demora Total Acumulada
                      </div>
                      <div className="text-3xl font-bold text-red-600">
                        +{formatearMinutos(tramo.minutosRetraso)}
                      </div>
                      <div className="text-xs text-red-700 mt-2">
                        El vehículo llegará {tramo.minutosRetraso} minutos
                        después de lo programado
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* SECCIÓN ORIGEN */}
          <div className="mb-6">
            <div className="bg-blue-50 border-l-4 border-blue-500 p-5 rounded-lg">
              <h3 className="font-bold text-blue-900 mb-4 flex items-center text-lg">
                <MapPin className="h-5 w-5 mr-2" />
                📍 Establecimiento Origen:{" "}
                {tramo.establecimientoOrigen?.nombre || "N/A"}
              </h3>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">
                    Llegada Programada
                  </div>
                  <div className="text-sm font-bold text-gray-900">
                    {formatDateTime(tramo.horaLlegadaProgramada)}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Llegada Real</div>
                  <div className="text-sm font-bold text-green-600">
                    {formatDateTime(tramo.horaLlegadaReal)}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Tardanza</div>
                  <div
                    className={`text-xl font-bold ${
                      tramo.tardanzaCita1 === 0
                        ? "text-green-600"
                        : tramo.tardanzaCita1 <= 15
                        ? "text-yellow-600"
                        : "text-red-600"
                    }`}
                  >
                    {tramo.tardanzaCita1 || 0} min
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Permanencia</div>
                  <div className="text-xl font-bold text-blue-600">
                    {tramo.tiempoPermanenciaCita1 || 0} min
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Atención</div>
                  <div className="text-xl font-bold text-green-600">
                    {tramo.tiempoAtencionCita1 || 0} min
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN TRÁNSITO */}
          {duracionTransito && (
            <div className="mb-6">
              <div className="bg-orange-50 border-l-4 border-orange-500 p-5 rounded-lg">
                <h3 className="font-bold text-orange-900 mb-4 flex items-center text-lg">
                  <TrendingUp className="h-5 w-5 mr-2" />
                  🚚 Tránsito (Origen → Destino)
                </h3>
                <div className="grid grid-cols-3 gap-4">
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">Inicio</div>
                    <div className="text-sm font-bold text-gray-900">
                      {formatDateTime(tramo.horaSalidaReal)}
                    </div>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">Duración</div>
                    <div className="text-2xl font-bold text-orange-600">
                      {duracionTransito} min
                    </div>
                    <div className="text-xs text-gray-500">
                      {(duracionTransito / 60).toFixed(1)}h
                    </div>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">Fin</div>
                    <div className="text-sm font-bold text-gray-900">
                      {formatDateTime(tramo.horaLlegadaRealDestino)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* SECCIÓN DESTINO */}
          <div className="mb-6">
            <div className="bg-green-50 border-l-4 border-green-500 p-5 rounded-lg">
              <h3 className="font-bold text-green-900 mb-4 flex items-center text-lg">
                <MapPin className="h-5 w-5 mr-2" />
                🎯 Establecimiento Destino:{" "}
                {tramo.establecimientoDestino?.nombre || "N/A"}
              </h3>

              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">
                    Llegada Programada
                  </div>
                  <div className="text-sm font-bold text-gray-900">
                    {formatDateTime(tramo.horaSalidaProgramada)}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Llegada Real</div>
                  <div className="text-sm font-bold text-green-600">
                    {formatDateTime(tramo.horaLlegadaRealDestino)}
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Tardanza</div>
                  <div
                    className={`text-xl font-bold ${
                      tramo.tardanzaCita2 === 0
                        ? "text-green-600"
                        : tramo.tardanzaCita2 <= 15
                        ? "text-yellow-600"
                        : "text-red-600"
                    }`}
                  >
                    {tramo.tardanzaCita2 || 0} min
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Permanencia</div>
                  <div className="text-xl font-bold text-green-600">
                    {tramo.tiempoPermanenciaCita2 || 0} min
                  </div>
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm">
                  <div className="text-xs text-gray-600 mb-1">Atención</div>
                  <div className="text-xl font-bold text-green-600">
                    {tramo.tiempoAtencionCita2 || 0} min
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RESUMEN */}
          <div className="bg-gradient-to-r from-indigo-50 to-purple-50 border-2 border-indigo-200 p-5 rounded-lg">
            <h3 className="font-bold text-indigo-900 mb-4 flex items-center text-lg">
              <CheckCircle className="h-5 w-5 mr-2" />
              📈 Resumen
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                <div className="text-xs text-gray-600 mb-1">Tardanza Total</div>
                <div className="text-xl font-bold text-red-600">
                  {(tramo.tardanzaCita1 || 0) + (tramo.tardanzaCita2 || 0)} min
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                <div className="text-xs text-gray-600 mb-1">Tiempo Origen</div>
                <div className="text-xl font-bold text-blue-600">
                  {tramo.tiempoPermanenciaCita1 || 0} min
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                <div className="text-xs text-gray-600 mb-1">
                  Tiempo Tránsito
                </div>
                <div className="text-xl font-bold text-orange-600">
                  {duracionTransito || "N/A"} min
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                <div className="text-xs text-gray-600 mb-1">Tiempo Destino</div>
                <div className="text-xl font-bold text-green-600">
                  {tramo.tiempoPermanenciaCita2 || 0} min
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                <div className="text-xs text-gray-600 mb-1">Estado</div>
                <div className="text-lg font-bold text-gray-900 capitalize">
                  {tramo.estado.replace("_", " ")}
                </div>
              </div>
            </div>
          </div>

          {/* 🆕 SECCIÓN DE PARADAS DETECTADAS */}
          {!loadingParadas && paradas.length > 0 && (
            <div className="mt-6">
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-300 p-5 rounded-lg">
                <h3 className="font-bold text-yellow-900 mb-4 flex items-center text-lg">
                  <PauseCircle className="h-5 w-5 mr-2" />
                  🛑 Paradas Detectadas en Ruta ({paradas.length})
                </h3>

                {/* Resumen rápido */}
                <div className="grid grid-cols-3 gap-3 mb-4">
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">
                      Total Paradas
                    </div>
                    <div className="text-2xl font-bold text-yellow-600">
                      {paradas.length}
                    </div>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">
                      Severidad Alta
                    </div>
                    <div className="text-2xl font-bold text-red-600">
                      {
                        paradas.filter(
                          (p) =>
                            p.severidad === "ALTA" || p.severidad === "CRÍTICA"
                        ).length
                      }
                    </div>
                  </div>
                  <div className="bg-white p-3 rounded-lg shadow-sm text-center">
                    <div className="text-xs text-gray-600 mb-1">
                      Tiempo Total
                    </div>
                    <div className="text-2xl font-bold text-orange-600">
                      {paradas.reduce((sum, p) => sum + p.duracionMinutos, 0)}{" "}
                      min
                    </div>
                  </div>
                </div>

                {/* Lista de paradas */}
                <div className="space-y-3">
                  {paradas.map((parada, index) => (
                    <div
                      key={index}
                      className={`p-4 rounded-lg border-2 ${
                        parada.severidad === "CRÍTICA" ||
                        parada.severidad === "ALTA"
                          ? "bg-red-50 border-red-300"
                          : "bg-white border-gray-200"
                      }`}
                    >
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex-1">
                          <div className="flex items-center space-x-2 mb-1">
                            <span className="font-bold text-gray-900 text-lg">
                              Parada #{index + 1}
                            </span>
                            <span
                              className={`px-2 py-1 rounded-full text-[10px] font-bold uppercase ${
                                parada.severidad === "BAJA"
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                              }`}
                            >
                              Severidad: {parada.severidad}
                            </span>
                          </div>
                          {/* Fallback si el motivo es null */}
                          <div className="text-sm font-semibold text-gray-700 italic">
                            {parada.motivo ||
                              "Parada detectada en trayecto (Sin motivo especificado)"}
                          </div>
                        </div>
                        <div className="text-right">
                          <div className="text-2xl font-bold text-orange-600">
                            {parada.duracionMinutos} min
                          </div>
                        </div>
                      </div>

                      {/* Detalles de Horas corregidos según tu JSON */}
                      <div className="grid grid-cols-2 gap-3 mb-2 bg-gray-50 p-2 rounded">
                        <div className="text-xs">
                          <span className="text-gray-500 block">Inicio:</span>
                          <span className="font-bold text-gray-800">
                            {formatDateTime(parada.horaInicio)}
                          </span>
                        </div>
                        <div className="text-xs">
                          <span className="text-gray-500 block">Fin:</span>
                          <span className="font-bold text-gray-800">
                            {formatDateTime(parada.horaFin)}
                          </span>
                        </div>
                      </div>

                      {/* Observaciones corregidas según tu JSON */}
                      {parada.observaciones ? (
                        <div className="text-[11px] text-gray-600 bg-white p-2 border border-dashed rounded mt-2">
                          <strong>Obs:</strong> {parada.observaciones}
                        </div>
                      ) : (
                        <div className="text-[10px] text-gray-400 mt-2 italic">
                          * No se registraron observaciones para esta parada.
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {loadingParadas && (
            <div className="mt-6 text-center py-8">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Analizando paradas en ruta...</p>
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="bg-gray-50 px-6 py-4 border-t flex items-center justify-between">
          <div className="text-xs text-gray-500">
            Generado: {new Date().toLocaleString("es-PE")}
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={generarReporte}
              className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              <Download className="h-4 w-4 mr-2" />
              Descargar Reporte
            </button>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalisisDemorasModal;
